<template>
  <div>
    <div class="fixed-top-bar d-flex align-center">
      <v-row>
        <!-- <v-col cols="1">
          <v-btn icon dark disabled="">
            <v-icon size="28px"> mdi-arrow-left-bold-box-outline </v-icon>
          </v-btn>
        </v-col>-->
        <v-col cols="4">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                @click="dialog = true"
                :disabled="selectedRows.length > 0"
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-file-plus-outline</v-icon>
                <span class="lable_class">Add</span>
              </v-btn>
            </template>
            <span>Add</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon dark v-bind="attrs" v-on="on" disabled class="ml-7 header_btn">
                <v-icon size="28px">mdi-clipboard-edit-outline</v-icon>
                <span class="lable_class">Edit</span>
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="assignRemoveFormDialog(true)"
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length == 0"
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-plus-circle-multiple-outline</v-icon>
                <span class="lable_class">Assign</span>
              </v-btn>
            </template>
            <span>Assign form(s) on selected records</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="assignRemoveFormDialog(false)"
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length == 0"
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-delete-sweep-outline</v-icon>
                <span class="lable_class">Delete</span>
              </v-btn>
            </template>
            <span>Remove form(s) from selected records</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length == 0"
                @click="delete_dialog = true"
                class="ml-7 header_btn"
              >
                <v-icon size="28px">mdi-delete-outline</v-icon>
                <span class="lable_class">Delete</span>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="activeDeactiveDialog()"
                icon
                dark
                v-bind="attrs"
                v-on="on"
                :disabled="selectedRows.length == 0"
                class="ml-10 header_btn"
              >
                <v-icon size="28px">mdi-plus-circle-multiple-outline</v-icon>
                <span class="lable_class">Active/Deactive</span>
              </v-btn>
            </template>
            <span>Active/Deactive selected records</span>
          </v-tooltip>
        </v-col>
        <!-- <v-col cols="6">
           <v-menu bottom offset-y :close-on-content-click="false" v-model="search_menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="setData({key : 'selected_alphabet',value : ''})" icon small dark v-bind="attrs" v-on="on" class="header_btn">
                <span class="lable_class">Search </span>
                 <v-badge overlap dot :value="search" color="error">
                  <v-icon size="28px">mdi-magnify</v-icon>
                  
                </v-badge>
              </v-btn>
            </template>
            <v-card tile width="300">
              <v-row no-gutters>
            <v-col cols="12" class="">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                dense
                solo
                clearable
                v-on:keyup.enter="search_menu = false"
                autofocus
              ></v-text-field>
            </v-col>
          </v-row>
            </v-card>
           </v-menu>
           <v-menu bottom :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn dark icon v-bind="attrs" v-on="on" disabled class="ml-7 header_btn">
                <v-icon size="22px">mdi-filter-menu-outline</v-icon>
                <span class="lable_class">Filter</span>
              </v-btn>
            </template>
           </v-menu>
        </v-col>-->
        <v-col cols="5">
          <v-menu
            bottom
            :close-on-content-click="false"
            content-class="elevation-0"
            v-model="filter_menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="pagination.filters.alphabet = ''"
                dark
                icon
                v-bind="attrs"
                v-on="on"
                class="ml-7 header_btn"
              >
                <span class="lable_class">Filter</span>
                <v-icon size="22px">mdi-filter-menu-outline</v-icon>
              </v-btn>
            </template>
            <v-card tile max-width="400" class="mb-5 mr-5">
              <v-list class="filter-section-border">
                <v-list-item class="mt-0">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    hide-details
                    dense
                    outlined
                    placeholder=" "
                    clearable
                    autofocus
                    v-on:keyup.enter="search_menu = false"
                    class="mr-2"
                  ></v-text-field>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="error"
                        @click="resetFilter()"
                        icon
                        small
                      >
                        <v-icon size="20" class="white--text">mdi-filter-remove-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Reset</span>
                  </v-tooltip>
                </v-list-item>
                <v-list-item class="mt-1">
                  <v-autocomplete
                    dense
                    flat
                    :items="status"
                    outlined
                    label="Status"
                    hide-details
                    class="body-2"
                    placeholder=" "
                    v-model="pagination.filters.doc_active"
                  ></v-autocomplete>
                </v-list-item>
              </v-list>
              <v-card-title class="pa-0">
                <v-btn
                  fab
                  color="error"
                  x-small
                  absolute
                  @click="filter_menu = false"
                  class="custom-close-btn"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
            </v-card>
          </v-menu>
        </v-col>
        <v-col cols="3" class="d-flex align-center justify-end">
          <span class="white--text font-weight-bold">
            Document Type
            <v-icon
              class="error--text ml-2"
              size="30"
              style="color:#ffffff !important"
              @click="logout()"
            >mdi-logout</v-icon>
          </span>
        </v-col>
      </v-row>
    </div>
    <v-overlay absolute :value="loading">
      <v-icon style="font-size: 80px;">mdi-progress-clock mdi-spin</v-icon>
    </v-overlay>
    <v-card flat tile>
      <v-card-text class="pa-0 mx-auto">
        <v-row dense class="pa-0 ma-0">
          <v-col cols="1" class="pa-0 ma-0" style="max-width: 2.5%;">
            <AlphabetSort />
          </v-col>
          <v-col class="pt-0 pr-0">
            <v-data-table
              :headers="headers"
              class="full-footer-bar elevation-1 rounded-0 my-transaction-table small-table fix-table-layout fix-table-header custom-width-800"
              item-key="user_id"
              :search="search"
              :items="items.data"
              :server-items-length="items.total"
              :options.sync="pagination"
              mobile-breakpoint="50"
              @item-expanded="expandRow"
              dense
              :footer-props="{
                'items-per-page-options': pagination_settings.perPageList,
              }"
            >
              <template v-slot:item="{ item }">
                <tr :class="(!item.doc_active)?'red lighten-5':''">
                  <td width="3%">
                    <v-icon @click="editRecord(item.doctype_id)">mdi-clipboard-edit-outline</v-icon>
                  </td>
                  <td width="7%">
                    <v-simple-checkbox
                      v-model="item.selected"
                      :ripple="false"
                      class="custom-simple-box"
                    ></v-simple-checkbox>
                  </td>
                  <td width="30%">{{item.title}}</td>
                  <td width="30%">
                    <!-- {{getModuleName(item.modules)}} -->
                    <v-autocomplete
                      style="margin-top: -1px;"
                      :items="module_list"
                      dense
                      v-model="modules[items.data.indexOf(item)]"
                      hide-details
                      multiple
                      @change="changeFormModule(items.data.indexOf(item),item)"
                    >
                      <template v-slot:selection="{index}">
                        <span
                          class="grey--text caption"
                          v-if="index == 0"
                        >{{selected_modules(items.data.indexOf(item))}}</span>
                      </template>
                    </v-autocomplete>
                  </td>
                  <td width="30%">{{item.doc_folder}}</td>
                </tr>
              </template>
              <template v-slot:header.select_all>
                <v-simple-checkbox
                  v-model="select_all_checkbox"
                  @input="changeSelectAll()"
                  color="white"
                  :ripple="false"
                  class="select-all-checkbox custom-simple-box"
                ></v-simple-checkbox>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog" persistent max-width="350px">
      <v-card :loading="form_loading">
        <v-card-title>
          <span class="headline">Add Document Type</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="12" class="mt-1">
                <v-text-field
                  label="Name*"
                  v-model="form_data.title"
                  :error-messages="form_error.title"
                  :hide-details="!form_error.title"
                ></v-text-field>
              </v-col>

              <v-col cols="12" class="mt-1">
                <v-autocomplete
                  :items="module_list"
                  label="Assign module"
                  dense
                  v-model="form_data.modules"
                  :error-messages="form_error.modules"
                  :hide-details="!form_error.modules"
                  multiple
                >
                  <template v-slot:selection="{ index }">
                    <span class="grey--text caption" v-if="index == 0">{{selected_multi_values}}</span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" class="mt-4">
                <!-- <v-text-field
                label="Folder Name"
                v-model="form_data.doc_folder"
                :error-messages="form_error.doc_folder"
                :hide-details="!form_error.doc_folder"
                ></v-text-field>-->
                <v-autocomplete
                  v-model="form_data.doc_folder"
                  dense
                  :items="doc_folder_name"
                  :error-messages="form_error.doc_folder"
                  :hide-details="!form_error.doc_folder"
                  label="Folder Name"
                  :search-input.sync="doc_search_value"
                  :menu-props="{closeOnContentClick:true}"
                  @change="changeExtraFolderNameAdd()"
                >
                  <template v-slot:item="{ item }">
                    <span style="width: 100%">
                      <span>{{ item.text }}</span>
                      <span class="float-right pl-2">
                        <v-icon
                          class="ml-2"
                          size="20px"
                          @click="renameFolderNamePopup(item.value);"
                        >mdi-clipboard-edit-outline</v-icon>
                      </span>
                    </span>
                  </template>
                  <template v-slot:no-data>
                    <div class="d-flex align-center">
                      <span
                        class="pl-2"
                        style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;"
                      >No Folder Found!</span>
                      <span
                        @click="addGroup"
                        class="mdi mdi-plus-circle pl-1 pr-2"
                        style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"
                      ></span>
                    </div>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" class="pa-2 pb-0 pt-1 mt-2" v-if="!form_data.doc_folder">
                <v-radio-group
                  inline
                  v-model="form_data.extra_folder"
                  :error-messages="form_error.extra_folder"
                  :hide-details="!form_error.extra_folder"
                >
                  <v-radio label="Customer" value="1"></v-radio>
                  <v-radio label="Vendor" value="2"></v-radio>
                  <v-radio label="Chart of Account" value="3"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" class="pa-2 pb-0 mt-2">
                <v-switch
                  class="pt-0 ma-0"
                  v-model="form_data.doc_active"
                  label="Active"
                  color="success"
                  dense
                  hide-details
                ></v-switch>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="dialog = false;form_data = {};form_error = {}">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="addRecord">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="edit_dialog" persistent max-width="350px">
      <v-card :loading="form_loading">
        <v-card-title>
          <span class="headline">Update Document Type</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="12" class="mt-1">
                <v-text-field
                  label="Name*"
                  v-model="edit_form_data.title"
                  :error-messages="edit_form_error.title"
                  :hide-details="!edit_form_error.title"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="mt-4">
                <v-autocomplete
                  :items="module_list"
                  label="Assign Module"
                  dense
                  v-model="edit_form_data.modules"
                  :error-messages="edit_form_error.modules"
                  :hide-details="!edit_form_error.modules"
                  multiple
                >
                  <template v-slot:selection="{ index }">
                    <span class="grey--text caption" v-if="index == 0">{{selected_multi_values2}}</span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" class="mt-4">
                <v-autocomplete
                  v-model="edit_form_data.doc_folder"
                  dense
                  :items="doc_folder_name"
                  :error-messages="form_error.doc_folder"
                  :hide-details="!form_error.doc_folder"
                  label="Folder Name"
                  :search-input.sync="doc_search_value"
                  :menu-props="{closeOnContentClick:true}"
                  @change="changeExtraFolderName();"
                >
                  <template v-slot:item="{ item }">
                    <span style="width: 100%">
                      <span>{{ item.text }}</span>
                      <span class="float-right pl-2">
                        <v-icon
                          class="ml-2"
                          size="20px"
                          @click="renameFolderNamePopup(item.value);"
                        >mdi-clipboard-edit-outline</v-icon>
                      </span>
                    </span>
                  </template>
                  <template v-slot:no-data>
                    <div class="d-flex align-center">
                      <span
                        class="pl-2"
                        style="font-size: 0.8125rem;font-weight: 500;line-height: 1rem;"
                      >No Folder Found!</span>
                      <span
                        @click="addGroup"
                        class="mdi mdi-plus-circle pl-1 pr-2"
                        style="font-size: 1.50rem;cursor: pointer;color: #6e9a35 !important;"
                      ></span>
                    </div>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" class="pa-2 pb-0 pt-1 mt-2" v-if="!edit_form_data.doc_folder">
                <v-radio-group inline v-model="edit_form_data.extra_folder">
                  <v-radio label="Customer" value="1"></v-radio>
                  <v-radio label="Vendor" value="2"></v-radio>
                  <v-radio label="Chart of Account" value="3"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" class="pa-2 pb-0 pt-1 mt-2">
                <v-switch
                  class="pt-0 ma-0"
                  v-model="edit_form_data.doc_active"
                  label="Active"
                  color="success"
                  dense
                  hide-details
                ></v-switch>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            @click="edit_dialog = false;edit_form_data = {};edit_form_data.module=[],edit_form_error = {}"
          >Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="updateRecord" dark>Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="delete_dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text>Are you sure you want to delete selected document types?</v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" text @click="delete_dialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" text @click="delete_dialog = false; deleteRecords()">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="assign_remove_form_dialog" persistent max-width="300px">
      <v-card :loading="form_loading">
        <v-card-title>
          <span class="headline">{{(is_assign_form)?'Assign Module(s)':'Remove Module(s)'}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-autocomplete
                  :items="module_list"
                  label="Module Name"
                  dense
                  v-model="selected_forms"
                  hide-details
                  multiple
                >
                  <template v-slot:selection="{ index }">
                    <span class="grey--text caption" v-if="index == 0">{{selected_multi_values3}}</span>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="assign_remove_form_dialog = false;selected_forms = [];">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :disabled="selected_forms.length == 0"
            @click="assignRemoveForms"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="active_deactive_dialog" persistent max-width="300px">
      <v-card :loading="form_loading">
        <v-card-title>
          <span class="headline">Status</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <v-col cols="3" class="pa-2 pb-0 pt-1">
                  <v-switch
                    class="pt-0 ma-0"
                    v-model="active_deactive"
                    label="Active"
                    color="success"
                    dense
                    hide-details
                  ></v-switch>
                </v-col>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="active_deactive_dialog = false;">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="activeDeactiveStatus">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="rename_folder_name_popup" max-width="400">
      <v-card>
        <v-card-title class="headline">Rename Folder Name</v-card-title>
        <v-card-text>
          <v-text-field label="Folder Name*" v-model="rename_folder_name"></v-text-field>
        </v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" text @click="rename_folder_name_popup = false">Cancel</v-btn>
          <v-btn color="red darken-1" text @click="renameFolderName();">Rename</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "../../plugins/axios";
import { parseParams, getAlphabets, logout } from "../../plugins/helper";
import AlphabetSort from "../AlphabetSort";
import { mapState, mapMutations } from "vuex";
export default {
  name: "DocumentType",
  data() {
    return {
      modules: [],
      dialog: false,
      edit_dialog: false,
      delete_dialog: false,
      is_assign_form: null,
      selected_forms: [],
      assign_remove_form_dialog: false,
      active_deactive: true,
      active_deactive_dialog: false,
      filter_menu: false,
      rename_folder_name_popup: false,
      rename_folder_name: "",
      folder_name: "",
      form_data: {
        modules: [],
        doc_active: true,
        extra_folder: "1",
        folder_name: ""
      },
      form_error: {},
      edit_form_data: {
        modules: [],
        doc_active: true,
        extra_folder: "",
        folder_name: ""
      },
      edit_form_error: {},
      search: "",
      doctype_id: null,
      form_loading: false,
      loading: false,
      items: {
        data: []
      },
      select_all_checkbox: false,
      headers: [
        { value: "", text: "#", sortable: false, class: "pl-3", width: "4%" },
        {
          value: "select_all",
          text: "",
          sortable: false,
          width: "7%",
          class: "pl-2"
        },
        { value: "checkbox", text: "", sortable: false, width: "3%" },
        { value: "title", text: "Name", sortable: false, width: "30%" },
        { value: "", text: "Assign Module", sortable: false, width: "30%" },
        {
          value: "doc_folder",
          text: "Folder Name",
          sortable: false,
          width: "30%"
        }
      ],
      module_list: [
        { value: "TRANSACTION", text: "Bank Transaction" },
        { value: "PROJECT", text: "Project" },
        { value: "ACCOUNT", text: "Chart of Account" },
        { value: "VENDOR", text: "Vendor" },
        { value: "CUSTOMER", text: "Customer" },
        { value: "ITEM", text: "Item" },
        { value: "USER", text: "User" },
        { value: "COMPANY", text: "Company" },
        { value: "CALENDARTASK", text: "Calendar Task" }
      ],
      status: [
        { text: "All", value: "all" },
        { text: "Active", value: "1" },
        { text: "Inactive", value: "0" }
      ],
      pagination: {
        itemsPerPage: 25,
        sortBy: ["title"],
        page: 1,
        filters: {
          alphabet: "",
          doc_active: "all"
        }
      },
      alphabets: getAlphabets(),
      expanded: [],
      search_menu: false,
      doc_search_value: "",
      doc_folder_name: []
    };
  },
  components: {
    AlphabetSort
  },
  computed: {
    ...mapState("utils", ["pagination_settings"]),
    ...mapState("submenu", ["selected_alphabet"]),

    selectedRows() {
      return this.items.data.filter(function(item) {
        return item.selected == true;
      });
    },
    pageData() {
      let paginationData = this.pagination;
      paginationData.search = this.search;
      paginationData.searchOption = "title";
      return paginationData;
    },
    selected_multi_values3() {
      let return_data = "";
      if (this.selected_forms.length > 0) {
        this.module_list.filter(item => {
          if (item.value == this.selected_forms[0]) {
            return_data = item.text;
          }
        });
        if (this.selected_forms.length > 1) {
          let totalVen = this.selected_forms.length - 1;
          return_data = return_data + " (" + totalVen + " More)";
        }
      }
      return return_data;
    },
    selected_multi_values() {
      let return_data = "";
      if (this.form_data.modules.length > 0) {
        this.module_list.filter(item => {
          if (item.value == this.form_data.modules[0]) {
            return_data = item.text;
          }
        });
        if (this.form_data.modules.length > 1) {
          let totalVen = this.form_data.modules.length - 1;
          return_data = return_data + " (" + totalVen + " More)";
        }
      }
      return return_data;
    },
    selected_multi_values2() {
      let return_data = "";
      if (this.edit_form_data.modules.length > 0) {
        this.module_list.filter(item => {
          if (item.value == this.edit_form_data.modules[0]) {
            return_data = item.text;
          }
        });
        if (this.edit_form_data.modules.length > 1) {
          let totalVen = this.edit_form_data.modules.length - 1;
          return_data = return_data + " (" + totalVen + " More)";
        }
      }

      return return_data;
    }
  },
  watch: {
    selected_alphabet(val) {
      this.pagination.filters.alphabet = val;
    },
    search() {
      this.getRecords();
    },
    pagination: {
      handler: function() {
        this.getRecords();
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations("submenu", ["setData"]),
    ...mapMutations("utils", ["setAlert"]),
    changeSelectAll() {
      if (this.select_all_checkbox) {
        this.items.data = this.items.data.map(item => {
          item.selected = true;
          return item;
        });
      } else {
        this.items.data = this.items.data.map(item => {
          item.selected = false;
          return item;
        });
      }
    },
    activeDeactiveStatus() {
      let ids = [];
      this.selectedRows.map(function(item) {
        ids.push(item.doctype_id);
      });
      let _self = this;
      _self.form_loading = true;
      axios
        .post("active_deactive_doc_type_status", {
          status: this.active_deactive,
          ids: ids
        })
        .then(() => {
          _self.form_loading = false;
          _self.active_deactive_dialog = false;
          _self.getRecords();
        })
        .catch(function() {
          _self.form_loading = false;
        });
    },
    assignRemoveForms() {
      let ids = [];
      this.selectedRows.map(function(item) {
        ids.push(item.doctype_id);
      });
      let _self = this;
      _self.form_loading = true;
      axios
        .post("assign_remove_document_type_module", {
          module: this.selected_forms,
          is_assign_form: this.is_assign_form,
          ids: ids
        })
        .then(() => {
          _self.form_loading = false;
          _self.assign_remove_form_dialog = false;
          _self.getRecords();
        })
        .catch(function() {
          _self.form_loading = false;
        });
    },
    assignRemoveFormDialog(is_assign_form) {
      this.is_assign_form = is_assign_form;
      this.selected_forms = [];
      this.assign_remove_form_dialog = true;
    },
    activeDeactiveDialog() {
      this.active_deactive_dialog = true;
    },
    editRecord(doctype_id) {
      this.doctype_id = doctype_id;
      this.edit_dialog = true;
      this.getDetails(doctype_id);
    },
    expandRow(itemData) {
      if (itemData.value) {
        this.items.data = this.items.data.map(function(item) {
          if (item.user_id == itemData.item.user_id) {
            item.selected = true;
          }
          return item;
        });
      }
    },
    getFormatedDate(date) {
      return new Date(date).toLocaleDateString();
    },
    getRecords() {
      let _self = this;
      this.loading = "accent";
      let url = parseParams(this.pageData);
      axios
        .get("document_type_list?" + url)
        .then(response => {
          if (_self.items.total != response.data.data.total) {
            _self.pagination.page = 1;
          }
          _self.items = response.data.data;
          _self.setData({ key: "alphabets", value: response.data.alphabets });
          let item_data = _self.items.data;
          for (let key in item_data) {
            _self.modules[key] = [];
            for (let key2 in item_data[key].docmodule) {
              _self.modules[key].push(item_data[key].docmodule[key2].module);
            }
          }
          _self.select_all_checkbox = false;
          _self.loading = false;
        })
        .catch(function() {
          _self.loading = false;
        });
    },
    addRecord() {
      let _self = this;
      _self.form_loading = true;
      axios
        .post("add_document_type", _self.form_data)
        .then(response => {
          _self.form_error = {};
          let data = response.data;
          if (!data.status) {
            _self.form_loading = false;
            for (let key in data.errors) {
              _self.form_error[key] = data.errors[key][0];
            }
          } else {
            _self.form_loading = false;
            _self.dialog = false;
            _self.getRecords();
            _self.form_data = {};
            _self.form_error = {};
            _self.getDocFolderName();
          }
        })
        .catch(function() {
          _self.form_loading = false;
        });
    },
    updateRecord() {
      let _self = this;
      _self.edit_form_data.doctype_id = _self.doctype_id;
      axios
        .post("update_document_type", _self.edit_form_data)
        .then(response => {
          _self.edit_form_data = {};
          _self.edit_form_error = {};
          let data = response.data;
          if (!data.status) {
            _self.form_loading = false;
            for (let key in data.errors) {
              _self.edit_form_error[key] = data.errors[key][0];
            }
          } else {
            _self.edit_form_data = {};
            _self.form_loading = false;
            _self.edit_dialog = false;
            _self.getRecords();
            _self.getDocFolderName();
          }
        })
        .catch(function() {
          _self.form_loading = false;
        });
    },
    changeFormModule(index, item) {
      let _self = this;
      this.loading = true;
      let data = {};
      data.doctype_id = item.doctype_id;
      data.title = item.title;
      data.doc_folder = item.doc_folder;
      data.modules = this.modules[index];
      axios
        .post("update_document_type", data)
        .then(() => {
          _self.loading = false;
        })
        .catch(function() {
          _self.loading = false;
        });
    },
    selected_modules(index) {
      let selected_modules = this.modules[index];
      let return_data = "";
      if (selected_modules.length > 0) {
        this.module_list.filter(item => {
          if (item.value == selected_modules[0]) {
            return_data = item.text;
          }
        });
        if (selected_modules.length > 1) {
          let totalVen = selected_modules.length - 1;
          return_data = return_data + " (" + totalVen + " More)";
        }
      }
      return return_data;
    },
    getDetails(doctype_id) {
      let _self = this;
      _self.form_loading = true;
      axios
        .get("get_document_type_details?doctype_id=" + doctype_id)
        .then(response => {
          let data = response.data.data;
          _self.edit_form_data.title = response.data.data.title;
          _self.edit_form_data.doc_folder = response.data.data.doc_folder;
          _self.edit_form_data.doc_active = response.data.data.doc_active;
          _self.edit_form_data.extra_folder = String(
            response.data.data.extra_folder
          );
          _self.edit_form_data.modules = [];
          for (let key in data.docmodule) {
            _self.edit_form_data.modules.push(data.docmodule[key].module);
          }
          _self.form_loading = false;
        })
        .catch(function() {
          _self.form_loading = false;
        });
    },
    deleteRecords() {
      let _self = this;
      let ids = [];
      this.selectedRows.map(function(item) {
        ids.push(item.doctype_id);
      });
      axios
        .post("delete_document_types", {
          ids: ids
        })
        .then(function(response) {
          _self.setAlert({
            show: true,
            variant: response.data.variant,
            message: response.data.message,
            dismissCountDown: 0
          });
          _self.getRecords();
        })
        .catch(function() {
          console.log("FAILURE!!");
        });
    },
    async getDocFolderName() {
      return axios
        .get("get_doc_folder_name")
        .then(response => {
          if (response.data.status) {
            this.doc_folder_name = response.data.doc_folder_name;
            return true;
          }
        })
        .catch(function() {
          return false;
        });
    },
    addGroup() {
      let _self = this;
      _self.doc_folder_name.push({
        value: _self.doc_search_value,
        text: _self.doc_search_value
      });
      _self.edit_form_data.doc_folder = _self.doc_search_value;
    },
    changeExtraFolderName() {
      if (
        this.edit_form_data.doc_folder != null &&
        this.edit_form_data.doc_folder != "" &&
        this.edit_form_data.doc_folder != "null"
      ) {
        this.edit_form_data.extra_folder = 0;
      } else {
        this.edit_form_data.extra_folder = "1";
      }
    },
    changeExtraFolderNameAdd() {
      if (
        this.form_data.doc_folder != null &&
        this.form_data.doc_folder != "" &&
        this.form_data.doc_folder != "null"
      ) {
        this.form_data.extra_folder = 0;
      } else {
        this.form_data.extra_folder = "1";
      }
    },
    logout() {
      logout(this.$router);
    },
    renameFolderNamePopup(value) {
      this.rename_folder_name_popup = true;
      this.folder_name = value;
      this.rename_folder_name = value;
    },
    renameFolderName() {
      let _self = this;
      // console.log('_self.folder_name', _self.folder_name);
      // console.log('_self.rename_folder_name', _self.rename_folder_name);
      axios
        .post("document/rename_folder_name", {
          folder_name: _self.folder_name,
          rename_folder_name: _self.rename_folder_name
        })
        .then(async response => {
          if (response.data.status) {
            await _self.getDocFolderName();
            _self.edit_form_data.doc_folder = _self.rename_folder_name;
            _self.form_data.doc_folder = _self.rename_folder_name;
            _self.rename_folder_name_popup = false;
          }
        })
        .catch(function() {
          _self.rename_folder_name_popup = false;
        });
    }
  },
  mounted() {
    this.getRecords();
    this.getDocFolderName();
  }
};
</script>